import tokens from '@kluein/design-tokens';
import { Box } from '@kluein/klue-ui';

import { useResponsive } from 'hooks/use-responsive';

import { AskKlueInput } from '../ask-klue-input';
import { AskKlueSingleClickPrompt } from '../ask-klue-single-click-prompt';

import type { AskKlueInputProps } from '../ask-klue-input/AskKlueInput';
import type { Source } from 'modules/shared/api/sources.api.types';

function AskKlueModalLandingScreen({
  handleAskKlue,
  activeChat,
  isResearchMode = false,
  modernSources,
  modernDisabledSources,
  onModernDisabledSourcesChange,
  isLoadingModernSources,
  consumerSourcesLocked,
}: {
  handleAskKlue: (question: string) => void;
  activeChat?: AskKlueInputProps['activeChat'];
  isResearchMode?: boolean;
  modernSources?: Source[];
  modernDisabledSources?: string[];
  onModernDisabledSourcesChange?: (disabled: string[]) => void;
  isLoadingModernSources?: boolean;
  consumerSourcesLocked?: boolean;
}) {
  const { maxWidth } = useResponsive();

  return (
    <Box
      align="center"
      height="100vh"
      gap="xxlarge"
      justify="center"
      pad={{ horizontal: tokens.spacing.xlarge }}
      width={maxWidth.small ? '100%' : '800px'}
    >
      <Box width="full">
        <AskKlueInput
          handleAskKlue={handleAskKlue}
          isModal={true}
          isInitalScreen={true}
          isResearchModeClickable={true}
          activeChat={activeChat}
          modernSources={modernSources}
          modernDisabledSources={modernDisabledSources}
          onModernDisabledSourcesChange={onModernDisabledSourcesChange}
          isLoadingModernSources={isLoadingModernSources}
          consumerSourcesLocked={consumerSourcesLocked}
        />
      </Box>
      <Box>
        <AskKlueSingleClickPrompt
          handleAskKlue={handleAskKlue}
          isInitalScreen={true}
          activeChat={activeChat}
          isResearchMode={isResearchMode}
        />
      </Box>
    </Box>
  );
}

export default AskKlueModalLandingScreen;
